import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { PersistConfig, persistReducer } from 'redux-persist';

import db from 'modules/localForage/db';
import { listToObject } from 'modules/main/service';
import { setBoats, setSelectedBoatId } from './actions';
import { Boat } from '../types';

const storage = createReducer({} as { [key: number]: Boat }, (builder) => {
  builder.addCase(setBoats, (state, action) => listToObject(action.payload));
});

const hasLoaded = createReducer(false, (builder) => {
  builder.addCase(setBoats, () => true);
});

const selectedBoatId = createReducer<number | null>(null, (builder) => {
  builder
    .addCase(setBoats, (state, action) => {
      const stillExists = action.payload.some((boat) => boat.id === state);
      if (state !== null && stillExists) return state;
      return action.payload[0]?.id ?? null;
    })
    .addCase(setSelectedBoatId, (state, action) => action.payload);
});

const reducer = combineReducers({
  storage,
  hasLoaded,
  selectedBoatId,
});

const boatsReducerConfig: PersistConfig<ReturnType<typeof reducer>> = {
  key: 'boat',
  storage: db.app,
  whitelist: ['storage', 'selectedBoatId'],
};

export const boatsReducer = persistReducer(boatsReducerConfig, reducer);
